import CallCenterDashboardSharedTables from "./CallCenterDashboardSharedTables";
import CallCenterCutOffAndComments from "./CallCenterCutOffAndComments";
import CallCenterDebtReschedulingTable from "./CallCenterDebtReschedulingTable";

function CallCenterMainDashboard() {

    return (
        <>
            <div className="bg-white callCenterMainDashboardHeader">Call Center Main Dashboard</div>
            <div className="callCenterMainDashboardContainer">
                {/* <CallCenterDashboardFilter /> */}
                <CallCenterDashboardSharedTables />
                <CallCenterCutOffAndComments /> 
                <CallCenterDebtReschedulingTable />
            </div>
        </>
    )
}

export default CallCenterMainDashboard